import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// managers
import { GrowlManager } from '../../manager/growl.manager';
import { DownloadManager } from '../../manager/download.manager';
// services
import { ServerMapping } from '../../service/serverMapping.service';

@Injectable()
export class DeliveryPrintService {

  constructor(private growlManager:     GrowlManager,
              private downloadManager:  DownloadManager,
              private serverMapping:    ServerMapping,
              private http:             Http) {}

  printDelivery(deliveryCode, printType) {
    this.http.get(this.serverMapping.deliveryPrintURL +
                  '?delivery_number=' + deliveryCode +
                  '&print_type=' + printType).subscribe(
      (response) => {
        const data = response.json();
        if (this.growlManager.checkForErrorInResponse(data)) {
          this.growlManager.showMessagesByResponse(data);
        }else if (data.download) {
          this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
        }
        console.log(data);
      },
      (error) => {
        console.log('--------------------------------');
        console.log('!!!An error has been occurred!!!');
        console.log(error);
        console.log('--------------------------------');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-delivery-print/delivery-print.service.ts